<div class="bn-not-found">
  <div class="bn-not-found__container">
    <img
      alt="Not found"
      class="bn-not-found__container__image"
      src="/assets/web-ui/images/bunny-repair-bot.svg"
      [ngStyle]="{
        'width.px': 521,
      }" />
    <div class="bn-not-found__container__title">{{ productName?.at(0) }} does not exist!</div>
    <div class="bn-not-found__container__description">Sorry we were not able to find the {{ productName?.at(0) }} you were looking for</div>
    <a
      bn-web-ui-button
      itemStyle="secondary"
      size="lg"
      [routerLink]="['/' + productRoute]">
      Go to {{ productName?.at(1) ?? productName?.at(0) + 's' }}
    </a>
  </div>
</div>
